<template>
  <div
  :class="selected && 'selected'"
  class="pricing-table elevation-3">
    <div
      class="pricing-table_title secondary"
    >
      <h3 v-if="cost_to_pay === 'enrollment_payment'" class="headline mb-0">{{ $t(`enrollments.registration`) }}</h3>
      <h3 v-else class="headline mb-0">{{ $t(`enrollments.annuity`) }}</h3>
    </div>
    <div class="pricing-table_content">
      <div v-if="totalPayments != 0 || step == 4" class="value">
        <div class="label">
          <span>{{ $t(`enrollments.registration_cost`) }}:</span>
        </div>
        <div class="price">
          <span>
            ${{ formatNumber(enrollment_costs.enrollment_payment) }}
          </span>
        </div>
      </div>
      <div v-if="cost_to_pay === 'yearly_pension_payment'" class="value">
        <div class="label">
          <span>{{ $t(`enrollments.pension_cost`) }}:</span>
        </div>
        <div class="price">
          <span>
            ${{ formatNumber(enrollment_costs.monthly_payment) }}
          </span>
        </div>
      </div>
      <div v-if="cost_to_pay === 'yearly_payment' && cost_to_pay !== 'yearly_pension_payment'" class="value">
        <div class="label">
          <span>{{ $t(`enrollments.pension_cost`) }}:</span>
        </div>
        <div class="price">
          <span>
            ${{ formatNumber(enrollment_costs.monthly_payment) }}
          </span>
        </div>
      </div>
      <div v-if="cost_to_pay === 'yearly_payment' && cost_to_pay !== 'yearly_pension_payment'" class="value total primary mb-1">
        <div class="label">
          <span>{{ $t(`enrollments.annuity_cost`) }}:</span>
        </div>
        <div class="price">
          <span>
            ${{ formatNumber(subtotal) }}
          </span>
        </div>
      </div>
      <div v-if="student.descuento_1 > 0" class="value total accent mb-1">
        <div class="label">
          <span>{{ $t(`enrollments.discount`) }}:</span>
        </div>
        <div class="price">
          <span>
            - ({{ student.descuento_1 }}%)  ${{ formatNumber(studentDiscount) }}
          </span>
        </div>
      </div>
      <div v-if="student.descuento_1 > 0" class="value total primary mb-1">
        <div class="label">
          <span>{{ $t(`enrollments.subtotal`) }}:</span>
        </div>
        <div class="price">
          <span>
            ${{ formatNumber(totalPartial) }}
          </span>
        </div>
      </div>
      <div v-if="cost_to_pay === 'yearly_payment' || cost_to_pay === 'yearly_pension_payment'" class="value discount success">
        <div class="label">
          <span>{{ $t(`enrollments.early_payment_discount`) }}:</span>
        </div>
        <div class="price">
          <span>
           - ({{ enrollment_costs.discount_early_payment }}%) ${{ formatNumber(discountYearly) }}
          </span>
        </div>
      </div>
      <div v-if="cost_to_pay === 'yearly_pension_payment'" class="value discount success mt-1">
        <div class="label">
          <span>{{ $t(`enrollments.reg_pay_discount`) }}:</span>
        </div>
        <div class="price">
          <span>
           - ({{ enrollment_costs.discount_early_payment }}%) ${{ formatNumber(discountYearlyEnrollment) }}
          </span>
        </div>
      </div>
      <div v-if="payments_total && totalPayments != 0" class="value discount success mt-1">
        <div class="label">
          <span>{{ $t(`enrollments.already_paid`) }}:</span>
        </div>
        <div class="price">
          <span>
           - ${{ formatNumber(payments_total) }}
          </span>
        </div>
      </div>
    </div>
    <div v-if="cost_to_pay === 'enrollment_payment' && other_concepts.filter(concept => concept.enrollment_payment > 0).length > 0" class="pricing-table_content">
      <h3>{{ $t(`enrollments.other_concepts`) }}:</h3>
      <v-divider></v-divider>
      <div
        :key="`enrr_concept${i}`"
        v-for="(other_concept, i) in other_concepts.filter(concept => concept.enrollment_payment > 0)"
        class="value">
        <div class="label">
          <v-checkbox
            color="primary"
            v-model="other_concepts_selected[`enrollment_payment-${other_concept.id}-${other_concept.enrollment_payment}`]"
            class="center"
            :label="other_concept.description"
            hide-details
          ></v-checkbox>
        </div>
        <div class="price">
          <span>
            ${{ formatNumber(other_concept.enrollment_payment) }}
          </span>
        </div>
      </div>
      <v-divider></v-divider>
    </div>
    <div v-if="cost_to_pay === 'yearly_payment' && other_concepts.filter(concept => concept.monthly_payment > 0).length > 0" class="pricing-table_content">
      <h3>{{ $t(`enrollments.other_concepts`) }}:</h3>
      <v-divider></v-divider>
      <div
        :key="`enrr_concept${i}`"
        v-for="(other_concept, i) in other_concepts.filter(concept => concept.monthly_payment > 0)"
        class="value">
        <div class="label">
          <v-checkbox
            color="primary"
            v-model="other_concepts_selected[`yearly_payment-${other_concept.id}-${other_concept.monthly_payment}`]"
            class="center"
            :label="other_concept.description"
            hide-details
          ></v-checkbox>
        </div>
        <div class="price">
          <span>
            ${{ formatNumber(other_concept.monthly_payment) }}
          </span>
        </div>
      </div>
      <v-divider></v-divider>
    </div>
    <div v-if="cost_to_pay === 'yearly_pension_payment' && other_concepts.filter(concept => concept.yearly_payment > 0).length > 0" class="pricing-table_content">
      <h3>{{ $t(`enrollments.other_concepts`) }}:</h3>
      <v-divider></v-divider>
      <div
        :key="`enrr_concept${i}`"
        v-for="(other_concept, i) in other_concepts.filter(concept => concept.yearly_payment > 0)"
        class="value">
        <div class="label">
          <v-checkbox
            color="primary"
            v-model="other_concepts_selected[`yearly_pension_payment-${other_concept.id}-${other_concept.yearly_payment}`]"
            class="center"
            :label="other_concept.description"
            hide-details
          ></v-checkbox>
        </div>
        <div class="price">
          <span>
            ${{ formatNumber(other_concept.yearly_payment) }}
          </span>
        </div>
      </div>
      <v-divider></v-divider>
    </div>
    <div class="pricing-table_content">
      <div v-if="extemp_enrollment" class="value extemp">
        <div class="label">
          <span>Recargo Extemp.:</span>
        </div>
        <div class="price">
          <span>
            ${{ formatNumber(extempTotal) }}
          </span>
        </div>
      </div>
      <div v-if="fee.fee > 0" class="value extemp">
        <div class="label">
          <span>{{ fee.detail.reason }}:</span>
        </div>
        <div class="price">
          <span>
            ${{ formatNumber(fee.fee) }}
          </span>
        </div>
      </div>
      <div v-if="acquisition > 0" class="value extemp mb-1">
        <div class="label">
          <span>Costo Por Adquirencia:</span>
        </div>
        <div class="price">
          <span>
            ({{ acquisition_price }}%)  ${{ formatNumber(acquisition) }}
          </span>
        </div>
      </div>
    </div>
    <div class="pricing-table_footer">
      <v-divider></v-divider>
        <div v-if="saldo_favor > 0" class="value total accent mb-1">
          <div class="label">
            <span>{{ $t(`enrollments.positive_balance`) }}:</span>
          </div>
          <div class="price">
            <span>
              - ${{ formatNumber(saldo_favor) }}
            </span>
          </div>
        </div>
        <div v-if="saldo_favor_config > 0" class="value total accent mb-1">
          <div class="label">
            <span>{{ $t(`enrollments.positive_balance`) }}:</span>
          </div>
          <div class="price">
            <span>
              - ${{ formatNumber(saldo_favor_config) }}
            </span>
          </div>
        </div>
        <div v-if="ext_payment.amount > 0" class="value total accent">
          <div class="label">
            <span>{{ ext_payment.detail.reason }}:</span>
          </div>
          <div class="price">
            <span>
              - ${{ formatNumber(ext_payment.amount) }}
            </span>
          </div>
        </div>
        <div class="value total primary">
          <div class="label">
            <span>{{ $t(`enrollments.total`) }}:</span>
          </div>
          <div class="price">
            <span>
              ${{ formatNumber(total) }}
            </span>
          </div>
        </div>
      <v-divider></v-divider>
      <v-btn
        @click="selectPricing(cost_to_pay)"
        :outline="!selected"
        :disabled="total <= 0 || cost_to_pay === 'yearly_payment' && payment && payment.payment_state === 'PARTIAL_EXPIRED'"  
        :color="selected ? 'success' : 'accent'">
        <v-icon v-if="selected">check</v-icon>
        {{
          noTotal ? $t(`enrollments.paid`) :
          selected ? $t(`enrollments.selected`) : $t(`enrollments.select`)
        }}
        </v-btn>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'enrollment-payment-component',
    props: {
      step: {
        type: Number,
        required: false
      },
      payment: {
        type: Object,
        required: false
      },
      cost_to_pay: {
        type: String,
        required: false
      },
      enrollment_costs: {
        type: Object,
        required: false
      },
      other_concepts: {
        type: Array,
        required: false
      },
      selected: {
        type: Boolean,
        required: false
      },
      extemp_enrollment: {
        type: Boolean,
        required: false
      },
      student: {
        type: Object,
        required: false,
      },
      saldo_favor: {
        type: Number,
        required: false,
        default: 0
      },
      saldo_favor_config: {
        type: Number,
        required: false,
        default: 0
      },
      acquisition_price: {
        type: Number,
        required: false
      },
      fee: {
        type: Object,
        required: false,
        default: () => ({ fee: 0, detail: {}})
      },
      ext_payment: {
        type: Object,
        required: false,
        default: () => ({ amount: 0, detail: {}})
      },
      payments_total: {
        type: Number,
        required: false,
        default: 0
      },
    },
    data() {
      return {
        other_concepts_selected: {}
      }
    },
    created () {
      this.sendTotalPay()
    },
    watch: {
      total(newValue, oldValue) {
        if (this.selected) {
          console.log("selected",this.selected)
          this.sendTotal()
        }
        this.sendTotalPay()
      }
    },
    computed: {
      subtotal() {
        let subtotal = 0
        if (this.cost_to_pay === 'enrollment_payment') subtotal = this.enrollment_costs.enrollment_payment
        if (this.cost_to_pay === 'yearly_payment') subtotal = this.enrollment_costs.enrollment_payment + this.enrollment_costs.monthly_payment
        if (this.cost_to_pay === 'yearly_pension_payment') subtotal = this.enrollment_costs.monthly_payment

        return subtotal
      },
      totalPayments() {
        let total = this.payments_total
        let student_discount = 0
        if (this.cost_to_pay === 'yearly_pension_payment' && this.payments_total) {
          if (this.student.descuento_1 > 0) student_discount = (this.enrollment_costs.enrollment_payment * (this.student.descuento_1 / 100))
          total = this.payments_total - (this.enrollment_costs.enrollment_payment - Math.round(student_discount))
        }
        return total
      },
      studentDiscount() {
        let student_discount = 0
        if (this.student.descuento_1 > 0) student_discount = (this.subtotal * (this.student.descuento_1 / 100))
        return Math.round(student_discount)
      },
      totalPartial() {
        return this.subtotal - this.studentDiscount
      },
      discountYearlyEnrollment() {
        let discount = 0
        let student_discount = 0
        if (this.student.descuento_1 > 0) student_discount = this.enrollment_costs.enrollment_payment - (this.enrollment_costs.enrollment_payment * (this.student.descuento_1 / 100))
        const discount_cost = this.enrollment_costs.discount_early_payment
        if (discount_cost && discount_cost > 0 && this.student.descuento_1 > 0 && this.cost_to_pay === 'yearly_pension_payment') {
          discount = (discount_cost * student_discount) / 100
        }

        if (discount_cost && discount_cost > 0 && this.student.descuento_1 <= 0 && this.cost_to_pay === 'yearly_pension_payment') {
          discount = (discount_cost * this.enrollment_costs.enrollment_payment) / 100
        }

        return Math.round(discount)
      },
      discountYearly() {
        let discount = 0
        const discount_cost = this.enrollment_costs.discount_early_payment
        if (discount_cost && discount_cost > 0 && this.cost_to_pay === 'yearly_payment' || this.cost_to_pay === 'yearly_pension_payment') {
          discount = (discount_cost * this.totalPartial) / 100
        }
        return Math.round(discount)
      },
      extempTotal() {
        let total_extemp = 0
        if (this.extemp_enrollment) {
          if (this.cost_to_pay === 'enrollment_payment') total_extemp = this.enrollment_costs.extemp_enrollment_payment
          if (this.cost_to_pay == 'yearly_payment') total_extemp = this.enrollment_costs.extemp_enrollment_payment + this.enrollment_costs.extemp_yearly_payment
        }

        return total_extemp
      },
      totalBeforeAcquisition() {
        const { total: total_concepts } = this.getOtherConceptsTotal(this.cost_to_pay)
        return (this.totalPartial - this.discountYearly + this.extempTotal + total_concepts + this.fee.fee) - this.saldo_favor - this.saldo_favor_config - this.ext_payment.amount - this.totalPayments - this.discountYearlyEnrollment
      },
      acquisition() {
        let acquisition_total = 0
        if (this.acquisition_price && this.acquisition_price > 0) {
          acquisition_total = (this.acquisition_price * this.totalBeforeAcquisition) / 100
        }
        return Math.round(acquisition_total)
      },
      total() {
        let enrollment = 0
        let student_discount = 0
        if (this.cost_to_pay === 'yearly_pension_payment' && this.payments_total === null) {
          if (this.student.descuento_1 > 0) student_discount = (this.enrollment_costs.enrollment_payment * (this.student.descuento_1 / 100))
          enrollment = this.enrollment_costs.enrollment_payment - Math.round(student_discount)
        }
        return Math.round(this.totalBeforeAcquisition + this.acquisition + enrollment)
      },
      noTotal() {
        return this.total <= 0
      }
    },
    methods: {
      getOtherConceptsTotal(payment_type) {
        const concepts = Object.keys(this.other_concepts_selected)
          .filter(concept => this.other_concepts_selected[concept])
          .map(concept => {
            const concept_value = concept.split('-')
            return {
              type: concept_value[0],
              concept_id: concept_value[1],
              price: concept_value[2],
            }
          })
          .filter(concept => concept.type === payment_type)


        const total = concepts
          .map(concept => this.other_concepts
              .filter(other_concept => other_concept.id == concept.concept_id)
              [0][payment_type]
          )
          .reduce((a, b) => a + b, 0)


        return {
          concepts,
          total,
        }

      },
      selectPricing(value) {
        this.$emit('selectCost', value)
        this.sendTotal()
      },
      sendTotal() {
        this.$emit('setTotal', this.total)
      },
      sendTotalPay() {
        this.$emit('setTotalPay', this.total)
      },
      formatNumber(number) {
        if(!number || typeof number === 'undefined') {
            return 0;
        } else {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
      },
    },
  }
</script>

<style scoped>
 .pricing-table{
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
 }

 .pricing-table_title {
   color: white;
   padding: 15px 15px;
 }

 .pricing-table_footer, .pricing-table_content {
   padding: 15px;
 }

 .value {
   padding: 10px 5px;
   display: flex;
   justify-content: space-between;
   align-items: flex-end;
 }

 .total {
   color: white;
   font-size: 20px;
   padding: 5px 15px;
 }

 .discount {
   font-size: 18px;
   color: white;
   padding: 5px 15px;
 }

 .label {
   font-weight: bold;
   font-size: 15px;
 }

 .price {
   font-weight: bold;
 }

 .pricing-table_footer {
   text-align: center;
 }

 .selected {
   animation: crecer 300ms ;
   transform: scale(1.04);
   border: solid 0.5px grey;
 }

 .extemp {
   color: brown;
   font-size: 14px !important;
 }

 @keyframes crecer {
   0% {
     transform: scale(1);

   }
   100% {
     transform: scale(1.04);
   }
 }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/enrollment/payment.vue